import { ExternalLink, Target } from "lucide-react";

/**
 * AmbassadorRow — persona-aware single row used by PublicLeaderboard.
 * Uses pre-rendered display fields from the backend so we don't leak persona-detection logic to the client.
 */
export default function AmbassadorRow({ row, color, showPoints = true }) {
  const isTop10 = row.is_top_10_pct;
  return (
    <div
      data-testid={`lb-row-${row.rank}`}
      className="flex items-center justify-between gap-3 px-5 py-4"
    >
      <div className="flex min-w-0 items-center gap-4">
        <span className="w-8 shrink-0 font-mono text-sm" style={color ? { color } : { color: "#71717a" }}>
          #{row.rank}
        </span>
        {row.display_image && (
          <img
            src={row.display_image}
            alt={`${row.display_name} logo`}
            className="h-9 w-9 shrink-0 rounded-md border border-zinc-800 bg-white object-contain p-0.5"
            data-testid={`lb-logo-${row.rank}`}
          />
        )}
        <div className="min-w-0">
          <div className="flex items-center gap-2">
            <p className={`truncate font-display text-base font-semibold ${row.needs_handle ? "italic text-zinc-500" : "text-white"}`}>{row.display_name}</p>
            {isTop10 && (
              <span
                data-testid={`lb-row-top10-${row.rank}`}
                className="inline-flex items-center gap-1 rounded-full border border-amber-400/50 bg-amber-500/10 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-amber-300"
                title="Top 10% of cohort"
              >
                <Target className="h-3 w-3" /> Top 10%
              </span>
            )}
          </div>
          {row.display_subtitle && (
            <p className="truncate text-xs text-zinc-400">
              {row.display_url ? (
                <a href={row.display_url} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 hover:text-[#A855F7]">
                  {row.display_subtitle} <ExternalLink className="h-3 w-3" />
                </a>
              ) : row.display_subtitle}
            </p>
          )}
          {row.display_meta && (
            <p className="truncate text-[11px] text-zinc-500">{row.display_meta}</p>
          )}
        </div>
      </div>
      <div className="flex items-center gap-6">
        <span className="hidden text-xs text-zinc-500 sm:inline">{row.referral_count} refs</span>
        {showPoints && <span className="font-mono text-base font-bold text-[#A855F7]">{row.points}</span>}
      </div>
    </div>
  );
}
